import { render } from "./App.vue?vue&type=template&id=2c0be2c2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2c0be2c2&lang=css"

import exportComponent from "/Users/mac/Desktop/Product/bdaim_official_website_pc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__